const topics = [
  {
    title: '动作大片专区',
    desc: '肾上腺素飙升的视觉盛宴，从好莱坞巨制到亚洲精品功夫片，高清画质带你沉浸热血世界。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20dramatic%20explosion%20effects%20and%20warm%20golden%20cinematic%20lighting%2C%20hero%20silhouette%20against%20fiery%20backdrop%2C%20epic%20movie%20poster%20style%2C%20rich%20contrast%2C%20no%20text%2C%20no%20faces&width=600&height=340&seq=carousel-action&orientation=landscape',
    tag: '动作',
  },
  {
    title: '悬疑推理剧场',
    desc: '烧脑剧情层层反转，精选全球高分悬疑佳作，每一帧都是线索，挑战你的推理极限。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20atmosphere%20with%20foggy%20alleyway%20and%20vintage%20street%20lamp%20glow%2C%20shadowy%20figure%20in%20distance%2C%20dark%20moody%20cinematic%20lighting%2C%20suspense%20thriller%20film%20noir%20aesthetic%2C%20rich%20blue%20and%20amber%20tones&width=600&height=340&seq=carousel-suspense&orientation=landscape',
    tag: '悬疑',
  },
  {
    title: '喜剧欢乐剧场',
    desc: '笑到停不下来！汇集国内外经典喜剧与新锐佳作，轻松一刻，治愈你的每个无聊夜晚。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20theater%20stage%20with%20warm%20colorful%20spotlights%2C%20festive%20atmosphere%2C%20red%20velvet%20curtain%20with%20golden%20trim%2C%20playful%20cinematic%20composition%2C%20joyful%20vibrant%20colors%2C%20no%20text%2C%20no%20people&width=600&height=340&seq=carousel-comedy&orientation=landscape',
    tag: '喜剧',
  },
  {
    title: '科幻巨制专题',
    desc: '穿越星际、探索未知，顶级科幻大片高清呈现。震撼视效与深度哲思的完美融合。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20holographic%20displays%20and%20neon%20blue%20ambient%20glow%2C%20sleek%20metallic%20surfaces%2C%20deep%20space%20visible%20through%20large%20viewport%2C%20cinematic%20sci-fi%20aesthetic%2C%20cool%20tones%20with%20warm%20accent%20lights&width=600&height=340&seq=carousel-scifi&orientation=landscape',
    tag: '科幻',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热门专题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            精选分类专题，快速找到你想看的类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.map((topic) => (
            <a
              key={topic.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium font-label">
                  {topic.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {topic.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {topic.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}